import React, { useContext } from 'react';
import { Button, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { theme } from '../../theme';
import { UserContext } from '../Hooks/useUser';
import CopyButton from '../CustomComponents/CopyButton';
import { Tooltip } from '@mui/material';

function ImplementerReviewCardHeader(props) {
    const { user } = useContext(UserContext);

    const primaryToggleText = {
        ready: 'Ready for Implementation',
        pending: 'Card Manager Review',
        complete: 'Implementation Complete',
    }

    function getPrimaryToggleText() {
        if (props.draft.status === 'applied') {
            return primaryToggleText['ready'];
        } else if (props.draft.status === 'implemented') {
            return primaryToggleText['complete'];
        }
        return primaryToggleText['pending'];
    }

    return (
        <Stack spacing={1} width='100%'>
            <Stack direction="row" justifyContent='space-between'>
                <Stack spacing={1}>
                    <Typography variant='normal' fontSize='14px'>
                        <strong>Physician: </strong> Dr. {props.draft.card.doctor.first_name} {props.draft.card.doctor.last_name}
                    </Typography>
                    <Typography variant='normal' fontSize='14px'>
                        <strong>Card: </strong> {props.draft.card.name} ({props.draft.card.external_card_id} <CopyButton textToCopy={props.draft.card.external_card_id} />)
                    </Typography>
                    <Typography variant='normal' fontSize='14px'>
                        <strong>Managed by: </strong> {props.draft.card.reviewers.map(reviewer => reviewer.first_name + ' ' + reviewer.last_name).join(', ')}
                    </Typography>
                </Stack>
                <Stack textAlign='end'>
                    <Typography variant='heavy' sx={{ fontSize: '16px' }}>{user?.name}</Typography>
                    <Typography variant='normal' color={theme.palette.subtext.main} sx={{ fontSize: '14px' }}>{user?.hospital?.name}</Typography>
                </Stack>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='end' justifyContent='space-between'>
                <Stack spacing={0.5}>
                    <ToggleButtonGroup
                        color='primary'
                        value={props.activeView}
                        exclusive
                        onChange={(event, value) => {
                            if (value !== null) { props.setActiveView(value); }
                        }}
                    >
                        <ToggleButton value='primaryView'>
                            {getPrimaryToggleText()}
                        </ToggleButton>
                        <ToggleButton value='allCardItems'>
                            All Card Items
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
                <Tooltip
                    title={'You can submit once all recommendations are reviewed. You will be able to submit this card once all optimizations have been reviewed.  For optimizations that you deny, don’t forget to leave feedback.'}
                    arrow
                    disableHoverListener={props.canSubmit}
                >
                    <Stack>
                        <Button variant='blueContained' disabled={!props.canSubmit} onClick={() => props.setIsShowingSubmitConfirmation(true)}>
                            Submit
                        </Button>
                    </Stack>
                </Tooltip>
            </Stack>
        </Stack>
    );
}

export default ImplementerReviewCardHeader;
